export default function ClauseCoverageCard({
  clause
}) {

  const coverageColor =
    clause.coverage_percent >= 80
      ? "bg-green-500"
      : clause.coverage_percent >= 50
      ? "bg-yellow-500"
      : "bg-red-500";

  return (
    <div className="bg-white border rounded-xl p-4 shadow-sm">

      <div className="flex items-center justify-between">

        <div>
          <div className="text-lg font-semibold">
            AS9100 {clause.clause_id}
          </div>

          <div className="text-sm text-gray-500 mt-1">
            Coverage Readiness
          </div>
        </div>

        <div className="text-right">

          <div className="text-2xl font-bold">
            {clause.coverage_percent}%
          </div>

          <div className="text-xs text-gray-500">
            coverage
          </div>
        </div>
      </div>

      <div className="w-full bg-gray-200 rounded-full h-3 mt-4">
        <div
          className={`${coverageColor} h-3 rounded-full`}
          style={{
            width: `${clause.coverage_percent}%`
          }}
        />
      </div>

      <div className="flex justify-between mt-4 text-sm">

        <div>
          <span className="font-semibold">
            Gaps:
          </span>{" "}
          {clause.total_gaps}
        </div>

        <div className="text-red-600 font-medium">
          High Risk: {clause.high_risk_gaps}
        </div>

      </div>
    </div>
  );
}